<accordion [isAnimated]="true" >
    <accordion-group [isOpen]="true">
      <span accordion-heading>
        <i class='fa fa-users'></i> Informacion General
      </span>
  
      <form class="form-horizontal" [formGroup]="bankRepresentativeForm" (ngSubmit)="searchRequest()">
        <div class="form-group row">
          <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Código de Solicitud</b>
            <span appRequiredAsterisk [formGroup]="bankRepresentativeForm" controlName="personalityDescription"></span>
          </label>
          <div class="col-10 col-md-10 col-sm-8 input-group">
            <input type="text" class="form-control"
              formControlName="mainRequestCode" [ngClass]="bankRepresentativeForm.controls.mainRequestCode.errors ? 'is-invalid' : 'is-valid'">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" (click)="searchRequest()" [disabled]="disabled"><i
                    class="fa fa-search"></i></button>
              </div>
          </div>
        </div>
      </form>
    </accordion-group>
    <accordion-group [isOpen]="true">
        <span accordion-heading>
          <i class='fa fa-info-circle'></i> Detalle de Solicitud
        </span>
        <app-credit-request-detail [creditRequestNumber]="creditRequestNumber" *ngIf="showDetail" (getRequest)="getRequest($event)" [showButtons]="false"></app-credit-request-detail>
    </accordion-group>
  </accordion>
  